/* eslint-disable react/no-danger */

import { EmojiConverter } from "./helpers";

function EmojiInput({
  top3Inputs,
  selectedIndex,
  selectEmoji,
}: {
  top3Inputs: string[];
  selectedIndex: number;
  selectEmoji: (a: string) => void;
}) {
  const selectedEmoji = top3Inputs[selectedIndex];

  if (!selectedEmoji) {
    return null;
  }
  return (
    <ul className="chat-input-select-list" data-testid="emoji-input">
      {top3Inputs.map((alias: string, index: number) => (
        <li
          key={alias}
          data-selected={index === selectedIndex}
          data-testid="emoji-input-item"
          onClick={() => {
            selectEmoji(alias);
          }}
        >
          <div
            className="emoji-img-div"
            dangerouslySetInnerHTML={{ __html: EmojiConverter.replace_colons(`:${alias}:`) }}
          />
          <span className="chat-input-complete" style={{ marginTop: "-3px" }}>
            {alias}
          </span>
        </li>
      ))}
    </ul>
  );
}

export { EmojiInput };
